import { rankings } from "@/mocks/manga";

const medal = ["text-accent-400", "text-secondary-300", "text-primary-500"];

export default function RankSection() {
  return (
    <section id="rank" className="py-14 md:py-20 bg-background-100/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
          <div>
            <p className="text-xs tracking-widest text-primary-400 mb-2">阅读排行 · 每周榜</p>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950">
              本周人气 TOP 榜
            </h2>
          </div>
        </div>

        <div className="space-y-3">
          {rankings.map((m, i) => (
            <article
              key={m.id}
              className="group flex items-center gap-4 md:gap-6 rounded-lg p-3 md:p-4 bg-background-100 border border-background-300/40 hover:border-primary-500/50 transition-colors"
            >
              <span
                className={`shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-md flex items-center justify-center font-heading text-lg font-black ${
                  i < 3 ? `bg-background-200 ${medal[i]}` : "bg-background-200/50 text-foreground-500"
                }`}
              >
                {String(i + 1).padStart(2, "0")}
              </span>

              <img
                src={m.cover}
                alt={`${m.title} 排行封面`}
                className="shrink-0 w-12 h-16 md:w-14 md:h-20 rounded-md object-cover object-top"
              />

              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 truncate">
                  {m.title}
                </h3>
                <p className="text-xs text-foreground-500 truncate mt-0.5">{m.desc}</p>
                <div className="flex flex-wrap gap-1.5 mt-1.5">
                  {m.tags.map((tag) => (
                    <span key={tag} className="px-1.5 py-0.5 rounded bg-secondary-200/40 text-secondary-300 text-[10px]">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>

              <div className="hidden sm:flex flex-col items-end gap-1 shrink-0">
                <span className="inline-flex items-center gap-1 text-accent-400 text-sm font-heading font-bold">
                  <i className="ri-star-fill text-xs"></i>
                  {m.rating.toFixed(1)}
                </span>
                <span className="text-[11px] text-foreground-500">{m.chapter}</span>
              </div>

              <div className="hidden md:flex items-center gap-1.5 text-xs text-foreground-400 shrink-0 w-24 justify-end">
                <i className="ri-eye-line"></i>
                {m.views}
              </div>

              <span className="shrink-0 w-9 h-9 rounded-md bg-primary-600/10 flex items-center justify-center text-primary-400 opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}